import { Loader } from "./Loader";
import { PolyList } from "./PolyList";
import { Input } from "./Input";
import { InputCollection } from "./InputCollection";
import { List } from "./List";
import { Source } from "./Source";
import { Geometry } from "./Geometry";

export class Mesh {

    public polylists: PolyList[];
    public vertexInputs: Input[];
    public sources: Source[];
    public geometry: Geometry;

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let geoReference = dataView.getInt32(offset, true);
        offset += 4;

        let sourceListReference = dataView.getInt32(offset, true);
        offset += 4;

        let vertexInputListReference = dataView.getInt32(offset, true);
        offset += 4;

        let polylistsResult = loader.util.readIdentityList < PolyList>(dataView, offset);
        this.polylists = polylistsResult.items;
        offset = polylistsResult.offset;

        this.vertexInputs = loader.getBlob<InputCollection>(vertexInputListReference).inputs;
        this.sources = loader.getBlob<List>(sourceListReference).getItems<Source>();
    }
}
